/*
export function someMutation (state) {
}
*/
export const setMe = (state, payload) => {
  state.me = payload
}
